export default "/static/9db3e3a65958292e.svg"